import React from 'react';

const SvgLocationFooter = () => {
    return (
        <svg style={{marginRight: "15.13px"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M20.62 8.45C19.57 3.83 15.54 1.75 12 1.75C12 1.75 12 1.75 11.99 1.75C8.45997 1.75 4.41997 3.82 3.36997 8.44C2.19997 13.6 5.35997 17.97 8.21997 20.72C9.27997 21.74 10.64 22.25 12 22.25C13.36 22.25 14.72 21.74 15.77 20.72C18.63 17.97 21.79 13.61 20.62 8.45Z" fill="white"/>
            <path d="M12 13.4602C13.7397 13.4602 15.15 12.0499 15.15 10.3102C15.15 8.57046 13.7397 7.16016 12 7.16016C10.2603 7.16016 8.84998 8.57046 8.84998 10.3102C8.84998 12.0499 10.2603 13.4602 12 13.4602Z" fill="white"/>
        </svg>
    );
};

export default SvgLocationFooter;